export class GapOrderAcceptanceRequest {
  id: number;
  poNumber: string;
  style: string;
  itemNo: string;
  buyerName: string;
  deliveryDate: string;
  transMode: string;
  deliveryAddress: string;
  color:string

}

export class GapApproveRequest {
  coReqDetails: {
    id: number;
    poNumber: string;
    style: string;
    itemNo: string;
    buyerName: string;
    deliveryDate: string;
    transMode: string;
    color:string
  }[]

}